import { render } from "./sponsors.vue?vue&type=template&id=0dee73bc&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=0dee73bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0dee73bc"

export default script